import { Badge, ErrorMessage, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { PageTitle } from "../components";
import { useListPartProperties } from "./ListPartProperties";

export const DraftListPartComponent: FC<IControlAttributes> = ({
    className, props
}) => {
    const { status, properties, error } = useListPartProperties(props)
    const { pageLink } = properties || {}

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (<div className={"inline-flex align-items-center position-relative"}>
        <Badge
            className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
            badgeStyle="primary">
            List Part
        </Badge>
        <div className={className}>
            {(!pageLink?.pageId) ? <>
                <p className="m-0 p-0 text-danger my-1 fs-8">Please update part page bindings.</p>
            </> : <>
                <PageTitle label="List Part Page" pageId={pageLink.pageId} />
            </>}
        </div>
    </div>)
}